import { TThunkAction } from '../../types/redux/thunk';
import { addFavoriteRequest } from '../../services/favorite';
import { addFavoriteSuccess } from './addFavoriteActions';
import { deleteFavoriteSuccess } from './deleteFavoriteActions';
import { trackAddFavorite } from './tracking';

interface IAddFavorite {
  offerId: number;
  label: string;
}

export const addFavorite =
  ({ offerId, label }: IAddFavorite): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi }) => {
    try {
      dispatch(addFavoriteSuccess({ offerId }));

      const response = await addFavoriteRequest({
        httpApi,
        parameters: {
          entityId: offerId,
        },
      });

      const { isAdded } = response;

      if (isAdded) {
        trackAddFavorite({ label, offerId });
      }

      if (!isAdded) {
        dispatch(deleteFavoriteSuccess({ offerId }));
      }
    } catch (error) {
      logger.error(error, {
        offerId,
        domain: 'src/shared/actions/favorite#addFavorite()',
        message: error.message,
      });

      dispatch(deleteFavoriteSuccess({ offerId }));
    }
  };
